import { AfterViewInit, ChangeDetectorRef, Component, inject, Input, OnChanges, PLATFORM_ID, SimpleChanges, ViewChild } from '@angular/core';
import { GoogleMap, GoogleMapsModule } from '@angular/google-maps';
import { Location } from './../../models/location.model';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { SheetService } from '../../../services/sheet.service';
import { PropertyService } from '../../../../features/property/services/property.service';


interface PropertyPreview extends Location {
  id: string;
  displayName?: string;
  city?: string;
  state?: string;
  name: string;      // The title/address
  lat: number;
  lng: number;
  imageUrl: string;  // Primary image URL for the preview
  linkUrl: string;   // Link to the full property page
  // Add other necessary fields (e.g., price, beds, baths)
}

@Component({
  selector: 'app-google-map',
  imports: [
    CommonModule,
    GoogleMap,
    GoogleMapsModule
  ],
  standalone: true,
  templateUrl: './google-map.html',
  styleUrl: './google-map.scss',
})
export class GoogleMapComponent implements AfterViewInit, OnChanges  {
  private propertyService = inject(PropertyService);
  private sheet = inject(SheetService);
  private cdr = inject(ChangeDetectorRef);

  @ViewChild(GoogleMap) map!: GoogleMap;
  ////@ViewChild('propertyInfoWindow') infoWindow!: MapInfoWindow;
  //@ViewChild(MapInfoWindow) infoWindow!: MapInfoWindow;
  @Input() locations: Location[] = [];
  @Input() zoom = 10;
  @Input() height = '300px'; // default height
  //selectedMarker: PropertyPreview | null = null;
  selectedMarker: PropertyPreview | null = null;   // bound in the template
  platformId = inject(PLATFORM_ID);
  private previousCenter!: google.maps.LatLngLiteral;
  private previousZoom!: number;
  private savedView?: {
    center: google.maps.LatLngLiteral;
    zoom: number;
  };

  center: google.maps.LatLngLiteral = { lat: 40.7128, lng: -74.0060 };
  
  markers: Location[] = [
    { lat: 40.7128, lng: -74.0060, name: 'New York', liked: false, imageUrl: '' },
    { lat: 40.7589, lng: -73.9851, name: 'Times Square', liked: true, imageUrl: '' }
  ];

  infoWindowContent = '';
  infoWindowPosition: google.maps.LatLngLiteral | null = null;

  ngAfterViewInit() {
    //this.setupMapListeners();
    if (this.locations.length > 0) {
      this.fitMarkersToView();
    }
    // this.map.mapClick.subscribe(() => {
    //   if (this.selectedMarker) {
    //     this.closeAndRestore();
    //   }
    // });
  }

  ngOnChanges(changes: SimpleChanges) {
    //console.log('google map changes');
    if (changes['locations']) {
      //console.log('🔄 Locations changed:', this.locations.length);
      if (this.locations.length > 0) {
        // this.clearMarkers();
        // this.center = { lat: this.locations[0].lat, lng: this.locations[0].lng };
        this.markers = this.locations;
        //this.cdr.detectChanges();
        //this.setupMapListeners();
        //this.fitMarkersToView();
        // this.savedView = {
        //   center: this.center,
        //   zoom: this.zoom
        // };
        if (this.map) {
          this.fitMarkersToView();
        }
        //console.log('google map locations after change', this.locations, this.markers);
      }
    }

    // if (changes['height']) {
    //   console.log('Height changed:', this.height, changes['height'].currentValue);
    //   this.setMapHeight(changes['height'].currentValue);
    // }
  }

  private fitMarkersToView() {
    //console.log('fit markers to view');
    if (!isPlatformBrowser(this.platformId) || typeof google === 'undefined') return;
    // Safety check
    if (!this.map?.googleMap || this.markers.length === 0) return;

    const bounds = new google.maps.LatLngBounds();
    this.markers.forEach(marker => {
      bounds.extend({ lat: marker.lat, lng: marker.lng });
    });
    //console.log('bounds', bounds);
    // Fit bounds handles both centering and zooming automatically
    this.map.googleMap.fitBounds(bounds);

    // Optional: Avoid being too zoomed in if there is only 1 marker
    if (this.markers.length === 1) {
      this.map.googleMap.setZoom(14); 
    }

    // if (!this.map.googleMap || this.markers.length === 0) return;
  
    // // ✅ STEP 1: CREATE BOUNDS FOR ZOOM
    // const bounds = new google.maps.LatLngBounds();
    // this.markers.forEach(marker => {
    //   bounds.extend({ lat: marker.lat, lng: marker.lng });
    // });
    
    // // ✅ STEP 2: CALCULATE EXACT CENTER!
    // const center = this.getMarkersCenter();
    
    // // ✅ STEP 3: SET CENTER + ZOOM
    // this.center = center;
    // this.map.googleMap.fitBounds(bounds, 10);
    
    // this.zoom = this.markers.length === 1 ? 10 : 3;

    // console.log('🎯 Centered at:', center.lat.toFixed(4), center.lng.toFixed(4), 'for', this.markers.length, 'markers');
  }

  private getMarkersCenter(): google.maps.LatLngLiteral {
    if (this.markers.length === 0) return { lat: 40.7128, lng: -74.0060 };
    
    // Sum all lat/lng
    const latSum = this.markers.reduce((sum, marker) => sum + marker.lat, 0);
    const lngSum = this.markers.reduce((sum, marker) => sum + marker.lng, 0);
    
    // Average = CENTER!
    const centerLat = latSum / this.markers.length;
    const centerLng = lngSum / this.markers.length;
    
    return { lat: centerLat, lng: centerLng };
  }

  // showInfoWindow(lat: number, lng: number, content: string) {
  //   console.log('showInfoWindow', lat, lng, content);
  //   this.infoWindowContent = content;
  //   this.infoWindowPosition = { lat, lng };
  //   this.cdr.detectChanges();
  // }

  onMarkerClick(marker: Location) {
    //this.showInfoWindow(marker.lat, marker.lng, marker.name || '');
    //console.log('marker click', marker);
    this.selectedMarker = marker as PropertyPreview;
    
    // Optional: Pan to the selected marker slightly offset to account for the sheet
    const offsetLat: number = marker.lat - 0.05; // Shift map up slightly
    const pos = { lat: offsetLat, lng: marker.lng };
    //console.log('pan to', pos);
    this.map.panTo(pos);
    
    this.cdr.detectChanges();
  }

  // openInfo(marker: MapMarker, property: Location) {
  //   this.selectedMarker = property as PropertyPreview;
  //   this.infoWindow.open(marker);

  //   // Zoom in on the marker
  //   const pos = { lat: property.lat, lng: property.lng };
  //   this.map.panTo(pos);
  //   this.map.zoom = Math.min((this.savedView?.zoom ?? 10) + 3, 18);

  //   // Hook native X button
  //   const nativeIw = this.infoWindow.infoWindow;
    
  //   if (nativeIw) {
  //     google.maps.event.clearListeners(nativeIw, 'closeclick');
  //     nativeIw.addListener('closeclick', () => this.closeAndRestore());
  //   }
  // }

  closeSheet() {
    this.selectedMarker = null;
    this.map.panTo(this.getMarkersCenter());
    this.cdr.detectChanges();
  }

  // private closeAndRestore() {
  //   this.selectedMarker = null;
  //   this.infoWindow.close();
    
  //   setTimeout(() => {
  //     if (this.savedView && this.map.googleMap) {
  //       const gmap = this.map.googleMap;
        
  //       gmap?.setZoom(this.savedView.zoom ?? 12);
  //       gmap?.panTo(this.savedView.center);
  //     }
  //   }, 0);
  // }

  clearMarkers() {
    this.markers = [];
  }

  // Map options
  get mapOptions(): google.maps.MapOptions {
    return {
      center: this.getMarkersCenter(),
      zoom: 12,
      zoomControl: true,
      mapTypeControl: false,
      streetViewControl: false,
      styles: [ 
        // 🏔️ LAND - Primary Blue Shades
        { elementType: 'geometry', stylers: [{ color: '#8599c0' }] },        // a30
        { elementType: 'geometry.fill', stylers: [{ color: '#b5c1d9' }] },   // a20
        
        // 🌊 WATER - Primary Green Shades  
        { featureType: 'water', elementType: 'geometry', stylers: [{ color: '#8dbfce' }] },     // a30
        { featureType: 'water', elementType: 'labels.text.fill', stylers: [{ color: '#5ba6bb' }] }, // a40

        // 🛣️ ROADS - Primary Blue + Orange Accents
        { featureType: 'road', elementType: 'geometry', stylers: [{ color: '#9dadcc' }] },      // a25
        { featureType: 'road', elementType: 'geometry.stroke', stylers: [{ color: '#8e4b0d' }] }, // Orange
        { featureType: 'road.highway', elementType: 'geometry', stylers: [{ color: '#0d508e' }] }, // Primary Blue
        { featureType: 'road.highway', elementType: 'geometry.stroke', stylers: [{ color: '#8e4b0d' }] }, // Orange

        // 🏙️ LABELS - Clean Blue/Green
        { elementType: 'labels.text.fill', stylers: [{ color: '#5373a7' }] },    // a40
        { elementType: 'labels.text.stroke', stylers: [{ color: '#ffffff' }] },  // White for contrast

        // 🌳 PARKS - Light Green
        { featureType: 'poi.park', elementType: 'geometry', stylers: [{ color: '#a5cbd8' }] },   // a25
        { featureType: 'poi.park', elementType: 'labels.text.fill', stylers: [{ color: '#3d99b1' }] }, // a45

        // 🏪 POINTS OF INTEREST - Subtle Blue
        { featureType: 'poi', elementType: 'labels.text.fill', stylers: [{ color: '#6d86b3' }] }, // a35

        // 🏘️ LOCALITY NAMES - Prominent Blue
        { featureType: 'administrative.locality', elementType: 'labels.text.fill', stylers: [{ color: '#37619a' }] }, // a45

        // 🔥 MAP RED ACCENTS - For important features
        { featureType: 'poi.attraction', elementType: 'labels.text.fill', stylers: [{ color: '#ff5d5c' }] } // Map Red
      ]
    };
  }

  // Marker options
  getMarkerOptions(index: number): google.maps.MarkerOptions {
    const colors = [
      '#ff5d5c',    // Map Red
      '#0d508e',    // Primary Blue  
      '#0d8e8c',    // Primary Green
      '#8e4b0d'     // Primary Orange
    ];
    
    return {
      // icon: {
      //   //path: google?.maps?.SymbolPath.CIRCLE || 0,
      //   // path: 0,
      //   scale: 10,
      //   // fillColor: colors[index % colors.length],
      //   // fillOpacity: 0.9,
      //   strokeWeight: 2,
      //   strokeColor: '#ffffff'
      // }
    };
  }

  openProperty(id: string) {
    if (id) {
      this.propertyService.getPropertyById(id).subscribe(async property => {
        const { PropertyView } = await import('../../../../features/property/components/property-view/property-view');
        this.sheet.open(PropertyView, { inputProperty: property });
      });
    }
  }
}
